
<template>
  <div class="select-map-pos-container">
    <div id="selectMap" style="width: 100%; height: 100%;"></div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listSystemInfo } from '@/api/system/systemInfoManageApi'

export default {
  name: 'SelectMapPos',
  props: {
    elementId: {
      type: String,
      default: 'selectMap'
    },
    initData: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      map: null,
      marker: null,
      communityId: '',
      mapData: {
        lat: 0,
        lng: 0
      },
      amapKey: ''
    }
  },
  async mounted() {
    this.communityId = getCommunityId()
    await this.loadAmapKey()
    await this.loadAmapScript()
  },
  methods: {
    async loadAmapKey() {
      try {
        const { data } = await listSystemInfo({ page: 1, row: 1 })
        if (data && data.length > 0 && data[0].qqMapKey) {
          this.amapKey = data[0].qqMapKey
        } else {
          // 使用您的默认Key
          this.amapKey = '2d4592252d5a8e57f8eb1b47aaef0d24'
        }
      } catch (error) {
        console.error('获取地图Key失败:', error)
        this.amapKey = '2d4592252d5a8e57f8eb1b47aaef0d24'
      }
    },

    loadAmapScript() {
      if (window.AMap) {
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://webapi.amap.com/maps?v=2.0&key=${this.amapKey}&plugin=AMap.ToolBar,AMap.Scale`
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },

    initMap(_data) {
      // 清除现有地图
      let _lng = 116.397128
      let _lat = 39.916527

      if (_data.lng) {
        _lng = _data.lng
      }

      if (_data.lat) {
        _lat = _data.lat
      }

      try {
        if (this.map) {
          this.map.destroy()
        }
      } catch (e) {
        console.log(e)
      }

      // 初始化高德地图
      let addMap = new window.AMap.Map('selectMap', {
        center: [_lng, _lat], // 高德地图中心点格式：[lng, lat]
        zoom: 13,
        viewMode: '2D'
      })

      let marker
      let _this = this

      // 添加点击事件监听
      addMap.on('click', function (event) {
        const lnglat = event.lnglat

        if (!marker) {
          marker = new window.AMap.Marker({
            position: [lnglat.getLng(), lnglat.getLat()],
            map: addMap
          })
        } else {
          marker.setPosition([lnglat.getLng(), lnglat.getLat()])
        }

        _this.$emit('position-change', {
          lat: lnglat.getLat(),
          lng: lnglat.getLng()
        })
      })

      this.map = addMap
    },

    addMarker(position) {
      // 清除现有标记
      if (this.marker) {
        this.marker.setMap(null)
      }

      // 创建新标记
      this.marker = new window.AMap.Marker({
        position: position,
        map: this.map,
        icon: '/img/maper.png',
        offset: new window.AMap.Pixel(-13, -30)
      })

      // 移动地图中心到标记位置
      this.map.setCenter(position)
      this.map.setZoom(16)
    },

    updatePosition(lat, lng) {
      if (!this.map) return

      const position = [lng, lat] // 高德地图位置格式：[lng, lat]
      this.addMarker(position)
    }
  },
  beforeDestroy() {
    // 组件销毁时清除地图实例
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  }
}
</script>

<style scoped>
.select-map-pos-container {
  width: 100%;
  height: 100%;
}
</style>
